import React, { useState, useEffect } from "react";
import ChatWindow from "./components/ChatWindow";
import KnowledgeUpload from "./components/KnowledgeUpload";
import { createConversation } from "./api";

function Chatbot() {
  const [conversationId, setConversationId] = useState(null);

  useEffect(() => {
    createConversation().then(c => setConversationId(c.id));
  }, []);

  return (
    <div className="App">
      <h1>Chat Support</h1>
      {conversationId && <ChatWindow conversationId={conversationId} />}
      <hr />
      <h2>Tudásfeltöltés</h2>
      <KnowledgeUpload />
    </div>
  );
}

export default Chatbot;